"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCCLILineSVATerminal = exports.getCCLITerminalCuote = exports.getCCLILineProducts = exports.getCCLINoFusionLandlineNumber = exports.getCCLIFusionLandlineNumber = exports.getCCLIMainFusionNumber = exports.getCCLIPersonalData = exports.initCCLICommunication = exports.ENDPOINTS = exports.ERROR = exports.CCLI_SRC_PATH = void 0;

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.sonda"));

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.monitoring-utils");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.types");

var _gerenciatdUtils4 = require("@bit/gerenciatd.utils.request");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CCLI_SRC_PATH = '/mimovistar-cliente/es-es/m_particulares/cclivr/proveedor.html?ccliToken=';
exports.CCLI_SRC_PATH = CCLI_SRC_PATH;
var ERROR = {
  COMMUNICATION: 'communicationKO',
  GET_INFO_ENTORNO: 'getInfoEntornoError',
  GET_PARQUE: 'getParqueError',
  GET_CUOTAS: 'getCuotasError'
};
exports.ERROR = ERROR;
var ENDPOINTS = {
  GET_INFO_ENTORNO: 'GetInfoEntorno',
  GET_PARQUE: 'GetParque',
  GET_CUOTAS: 'GetCuotas'
};
exports.ENDPOINTS = ENDPOINTS;

var initCCLICommunication = function initCCLICommunication(idIframe, callback, context) {
  var idRequest = _gerenciatdUtils2.api.getUUID('VT');

  var sondaInfoEntorno = new _gerenciatdUtils["default"]({
    eventName: 'CCLI.GET_INFO_ENTORNO',
    context: context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API'
  });
  var name = context.environment.name;
  var mockInfo = (0, _gerenciatdUtils4.getMockedInfo)(ENDPOINTS.GET_INFO_ENTORNO, name);

  if (mockInfo) {
    callback(JSON.parse(mockInfo.rawResponse));
  } else if (ccliComunicacion) {
    var iframe = document.getElementById(idIframe);

    if (iframe) {
      var comunicacionOk = false;
      ccliComunicacion.listen();
      var CCLIsrc = "".concat(CCLI_SRC_PATH).concat(encodeURIComponent(ccliComunicacion.tokenWithChildren));
      iframe.setAttribute('src', CCLIsrc); // Starting to check communication

      var comienzoInterval = Date.now();
      var idNoOp = ccliComunicacion.newGUID();
      var checkComunicacion = setInterval(function () {
        if (Date.now() - comienzoInterval > 30000) {
          clearInterval(checkComunicacion);

          if (!comunicacionOk) {
            var error = ERROR.COMMUNICATION;
            sondaInfoEntorno.endWS(_gerenciatdUtils3.WSElementType.ERROR_TIMEOUT);
            callback({
              error: error
            });
          }
        } else {
          var iframeWindow = iframe.contentWindow || iframe.contentDocument && iframe.contentDocument.parentWindow;

          if (iframeWindow) {
            // Check communication with Noop method
            ccliComunicacion.sendRequestAsync(iframeWindow, idNoOp, 'NoOp', null).then(function (respuestaNoOp) {
              clearInterval(checkComunicacion);

              if (respuestaNoOp.result.code === 0) {
                comunicacionOk = true;
                sondaInfoEntorno.startWS();
                ccliComunicacion.sendRequestAsync(iframeWindow, null, ENDPOINTS.GET_INFO_ENTORNO, null).then(function (response) {
                  if (response && response.result.code === 0) {
                    sondaInfoEntorno.endWS(_gerenciatdUtils3.WSElementType.OK);
                    callback(response.result.data);
                  } else {
                    var _error = ERROR.GET_INFO_ENTORNO;
                    sondaInfoEntorno.endWS(_gerenciatdUtils3.WSElementType.KO);
                    callback({
                      error: _error
                    });
                  }
                });
              }
            });
          }
        }
      }, 250);
    }
  }
};

exports.initCCLICommunication = initCCLICommunication;

var getCCLIPersonalData = function getCCLIPersonalData(infoEntornoData) {
  var personalData = {};

  if (infoEntornoData && infoEntornoData.usuario) {
    var usuario = infoEntornoData.usuario;
    personalData.fullName = usuario.nombre ? "".concat(usuario.nombre, " ").concat(usuario.apellido1, " ").concat(usuario.apellido2) : usuario.razonSocial;
    personalData.name = usuario.nombre;
    personalData.businessName = usuario.razonSocial;
    personalData.surname1 = usuario.apellido1;
    personalData.surname2 = usuario.apellido2;
    personalData.docType = usuario.tipoDocumento;
    personalData.docTypeFixed = usuario.tipoDocumentoFija;
    personalData.docNumber = usuario.documento;

    var _usuario$emails = _slicedToArray(usuario.emails, 1),
        email = _usuario$emails[0];

    personalData.email = email;
  }

  return personalData;
};

exports.getCCLIPersonalData = getCCLIPersonalData;

var getCCLIMainFusionNumber = function getCCLIMainFusionNumber(infoEntornoData) {
  var fusionNumberInfo = {};

  if (infoEntornoData && infoEntornoData.lineas && Array.isArray(infoEntornoData.lineas)) {
    // CCLI says 'tipo' is always filled
    var numberElement = infoEntornoData.lineas.find(function (line) {
      return line.tipo === 'MovilContratoFusionPrincipal';
    });

    if (numberElement) {
      fusionNumberInfo.msisdn = numberElement.msisdn;
      fusionNumberInfo.codigoPlanFacturacion = numberElement.codigoPlanFacturacion;
      fusionNumberInfo.codigoPlanTarificacion = numberElement.codigoPlanTarificacion;
    }
  }

  return fusionNumberInfo;
};

exports.getCCLIMainFusionNumber = getCCLIMainFusionNumber;

var getCCLIFusionLandlineNumber = function getCCLIFusionLandlineNumber(infoEntornoData) {
  var landline = '';

  if (infoEntornoData && infoEntornoData.lineas && Array.isArray(infoEntornoData.lineas)) {
    // CCLI says 'tipo' is always filled
    var numberElement = infoEntornoData.lineas.find(function (line) {
      return line.tipo === 'FijaFusion';
    });

    if (numberElement) {
      landline = numberElement.msisdn;
    }
  }

  return landline;
};

exports.getCCLIFusionLandlineNumber = getCCLIFusionLandlineNumber;

var getCCLINoFusionLandlineNumber = function getCCLINoFusionLandlineNumber(infoEntornoData) {
  var landline = '';

  if (infoEntornoData && infoEntornoData.lineas && Array.isArray(infoEntornoData.lineas)) {
    // CCLI says 'tipo' is always filled
    var numberElement = infoEntornoData.lineas.find(function (line) {
      return line.tipo === 'FijaNoFusion';
    });

    if (numberElement) {
      landline = numberElement.msisdn;
    }
  }

  return landline;
};

exports.getCCLINoFusionLandlineNumber = getCCLINoFusionLandlineNumber;

var getCCLILineProducts = function getCCLILineProducts(idIframe, mobilePhone, callback, context) {
  var ofertabilidad = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var idRequest = _gerenciatdUtils2.api.getUUID('VT');

  var sondaGetParque = new _gerenciatdUtils["default"]({
    eventName: 'CCLI.GET_PARQUE',
    context: context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API'
  });
  var name = context.environment.name;
  var mockInfo = (0, _gerenciatdUtils4.getMockedInfo)(ENDPOINTS.GET_PARQUE, name);

  if (mockInfo) {
    callback(JSON.parse(mockInfo.rawResponse));
  } else {
    var iframe = document.getElementById(idIframe);
    var iframeWindow = iframe.contentWindow || iframe.contentDocument && iframe.contentDocument.parentWindow;
    sondaGetParque.startWS();
    ccliComunicacion.sendRequestAsync(iframeWindow, null, ENDPOINTS.GET_PARQUE, {
      msisdn: mobilePhone,
      ofertabilidad: ofertabilidad
    }).then(function (response) {
      if (response && response.result.code === 0) {
        sondaGetParque.endWS(_gerenciatdUtils3.WSElementType.OK);

        var _response$result$data = _slicedToArray(response.result.data, 1),
            infoGetParque = _response$result$data[0];

        callback(infoGetParque);
      } else {
        sondaGetParque.endWS(_gerenciatdUtils3.WSElementType.KO);
        var error = ERROR.GET_PARQUE;
        callback({
          error: error
        });
      }
    })["catch"](function () {
      sondaGetParque.endWS(_gerenciatdUtils3.WSElementType.KO);
      var error = ERROR.GET_PARQUE;
      callback({
        error: error
      });
    });
  }
};

exports.getCCLILineProducts = getCCLILineProducts;

var getCCLITerminalCuote = function getCCLITerminalCuote(idIframe, mobilePlan, arrayR2RServices, callback, context) {
  var idRequest = _gerenciatdUtils2.api.getUUID('VT');

  var sondaGetCuote = new _gerenciatdUtils["default"]({
    eventName: 'CCLI.GET_CUOTAS',
    context: context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API'
  });
  var name = context.environment.name;
  var mockInfo = (0, _gerenciatdUtils4.getMockedInfo)(ENDPOINTS.GET_CUOTAS, name);

  if (mockInfo) {
    callback(JSON.parse(mockInfo.rawResponse));
  } else {
    var iframe = document.getElementById(idIframe);
    var iframeWindow = iframe.contentWindow || iframe.contentDocument && iframe.contentDocument.parentWindow;
    sondaGetCuote.startWS();
    ccliComunicacion.sendRequestAsync(iframeWindow, null, ENDPOINTS.GET_CUOTAS, {
      plan: mobilePlan,
      servicios: arrayR2RServices
    }).then(function (response) {
      if (response && response.result.code === 0) {
        sondaGetCuote.endWS(_gerenciatdUtils3.WSElementType.OK);
        var infoTerminalCuote = response.result.data;
        callback(infoTerminalCuote);
      } else {
        sondaGetCuote.endWS(_gerenciatdUtils3.WSElementType.KO);
        var error = ERROR.GET_CUOTAS;
        callback({
          error: error
        });
      }
    })["catch"](function () {
      sondaGetCuote.endWS(_gerenciatdUtils3.WSElementType.KO);
      var error = ERROR.GET_CUOTAS;
      callback({
        error: error
      });
    });
  }
};

exports.getCCLITerminalCuote = getCCLITerminalCuote;

var getCCLILineSVATerminal = function getCCLILineSVATerminal(infoParque, svaCode) {
  var sva = '';
  var sa = '';

  if (infoParque.productos && Array.isArray(infoParque.productos)) {
    var _infoParque$productos = _slicedToArray(infoParque.productos, 1),
        product = _infoParque$productos[0];

    if (product && product.secciones && Array.isArray(product.secciones)) {
      var _product$secciones = _slicedToArray(product.secciones, 1),
          services = _product$secciones[0];

      if (services.elementos && Array.isArray(services.elementos)) {
        sa = services.elementos.find(function (service) {
          return service.codServicio.substring(0, 4) === 'RENT';
        });
        sva = services.elementos.find(function (service) {
          return service.codServicio === svaCode;
        });
      }
    }
  }

  return {
    svaTerminal: sva,
    saTerminal: sa
  };
};

exports.getCCLILineSVATerminal = getCCLILineSVATerminal;

//# sourceMappingURL=index.js.map